// extracted by mini-css-extract-plugin
export default {"error-screen":"error-screen__S6yk+","title":"title__5s3Uy","logo":"logo__zgCXN","description":"description__qXMEJ"};